import { fromJS } from 'immutable';
import {
  SET_VALIDATED_CLAIMS,
  SET_SEARCH,
} from 'containers/ValidatedClaimsPage/constants';
import { RESET_STORE } from 'containers/LoginPage/constants';
import { get } from 'lodash';

const initialState: any = fromJS({
  claims: [],
  countClaims: 0,
});

const validatedClaimsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_VALIDATED_CLAIMS:
      return state
        .set('claims', fromJS(action.response.claims))
        .set('countClaims', fromJS(action.response.total));
    case SET_SEARCH:
      return state
        .set('claims', fromJS(action.data))
        .set('countClaims', fromJS(get(action, 'data', []).length));
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};

export default validatedClaimsReducer;
